/** 系统 APK 注入的右上角「D」调试浮窗：在 document-start / head 即阻断，避免先闪现再被移除 */

const HIDE_STYLE_ID = '__aimeta_dbg_hide_style';
const HIDE_STYLE_CSS =
  '#__aimeta_dbg_toggle,#__aimeta_debug_panel,#__aimeta_dbg_body{display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important}';

type AimetaDebugWindow = Window & {
  __AIMETA_DISABLE_DEBUG_OVERLAY__?: boolean;
  __AIMETA_DEBUG__?: boolean;
};

/** 置位后系统 debug_overlay.js 会直接 return，不会创建 DOM */
export function blockNativeDebugOverlay(): void {
  if (typeof window === 'undefined') return;
  const w = window as AimetaDebugWindow;
  w.__AIMETA_DISABLE_DEBUG_OVERLAY__ = true;
  // 勿 delete：删除后系统 onPageFinished 会再次注入并短暂显示「D」
  w.__AIMETA_DEBUG__ = true;
}

function ensureHideStyle(): void {
  if (typeof document === 'undefined') return;
  if (document.getElementById(HIDE_STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = HIDE_STYLE_ID;
  style.textContent = HIDE_STYLE_CSS;
  (document.head || document.documentElement).appendChild(style);
}

function removeDebugOverlayNodes(): void {
  if (typeof document === 'undefined') return;
  document.getElementById('__aimeta_debug_panel')?.remove();
  document.getElementById('__aimeta_dbg_toggle')?.remove();
  document.getElementById('__aimeta_dbg_body')?.remove();
}

/** 阻断注入 + 隐藏样式 + 清除已插入节点 */
export function stripNativeDebugOverlay(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  blockNativeDebugOverlay();
  ensureHideStyle();
  removeDebugOverlayNodes();
}

/** 原生可能在 onPageFinished 后延迟注入，持续监听并清除 */
export function watchAndStripNativeDebugOverlay(maxMs = 60000): void {
  if (typeof document === 'undefined') return;

  stripNativeDebugOverlay();

  const observer = new MutationObserver(() => {
    if (
      document.getElementById('__aimeta_debug_panel') ||
      document.getElementById('__aimeta_dbg_toggle')
    ) {
      stripNativeDebugOverlay();
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), maxMs);
}

/** 路由/切页后再次阻断（系统 APK 会在 onPageFinished 重复注入） */
export function scheduleStripNativeDebugOverlay(): void {
  if (typeof window === 'undefined') return;
  const delays = [0, 50, 200, 500, 1200];
  for (const ms of delays) {
    if (ms === 0) {
      stripNativeDebugOverlay();
    } else {
      window.setTimeout(stripNativeDebugOverlay, ms);
    }
  }
}
